import HttpClient from "../helpers/HttpClient"
import { HttpError, isError } from "../helpers/Error"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import { NewBulkOperationPayload } from "./BulkOperationPayload"
import BulkOperation, {BulkOperationDto } from "./BulkOperation"

class BulkService {
    private static httpClient = new HttpClient<BulkOperation, BulkOperationDto>(BulkOperation)
    static async CreateBulkOperation(payload: NewBulkOperationPayload) {
        return AppContext.getApiClient().post("/bulk-operations", payload)
    }

    static async RetrieveBulkOperation(id: string) {
        return this.httpClient.get(`/bulk-operation/${id}`)
    }

    static async GetPendingBulkOperationsByUser(): Promise<HttpError|BulkOperation[]> {
        const res = await this.httpClient.get("/bulk-operations/by-user")
        if (isError(res)) {
            return res as HttpError
        }
        return res as BulkOperation[]
        
    }
}

export default BulkService



// WEBPACK FOOTER //
// ./src/state/bulk-operation/BulkService.ts